module.exports = __webpack_public_path__ + "static/media/STM_social_whatsapp_Black.6971d2df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/STM_social_whatsapp_Black.png
// module id = 34
// module chunks = 0